import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2 4.48598C2 3 3 2 4.48598 2H38V35.514C38 37 37 38 35.514 38H2V4.48598ZM29.4704 12.8629C29.4704 10.1235 27.2597 7.89753 24.5204 7.87863L11.4019 7.78816V32.2118H14.3302V21.4953H16.7379C16.9134 21.0303 17.0093 20.5264 17.0093 20C17.0093 19.497 16.9217 19.0146 16.7609 18.567H14.3302V10.7165H24.2368C25.5099 10.7165 26.5421 11.7486 26.5421 13.0218V16.2617C26.5421 17.5349 25.5099 18.567 24.2368 18.567H21.1838V21.4953L22.3842 21.5134L29.8442 32.2118H33.271L25.7246 21.3894C27.8754 20.8393 29.4704 18.8882 29.4704 16.56V12.8629ZM6.66667 12.2118V27.7882H10.9034V24.8598H9.59502V15.1402H10.9034V12.2118H6.66667ZM20.5607 20C20.5607 23.5443 18.1932 26.5356 14.9533 27.4787V24.3443C16.5422 23.5451 17.6324 21.8999 17.6324 20C17.6324 18.1001 16.5422 16.4549 14.9533 15.6557V12.5213C18.1932 13.4644 20.5607 16.4557 20.5607 20Z",
			fill: "#2798D4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.36137 0C1.95265 0 0 1.95265 0 4.36137V40H35.6386C38.0473 40 40 38.0474 40 35.6386V0H4.36137ZM39 1H4.36137C2.46881 1 1 2.46881 1 4.36137V39H35.6386C37.5312 39 39 37.5312 39 35.6386V1Z",
			fill: "#2798D4"
		})
	]
});
const ForwardRef = forwardRef(SvgLogoIcon);
export default ForwardRef;
